'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _utils = require('../utils');

var _captcha = require('../actions/captcha');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
    isFetching: false,
    exp: Date.now()
};

var captchaReducer = function captchaReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _captcha.REQUEST_CAPTCHA:
            return _extends({}, state, {
                isFetching: true,
                exp: +(0, _moment2.default)().add(1, 'm')
            });
        case _captcha.RECEIVE_CAPTCHA:
            return _extends({}, state, {
                isFetching: false,
                lastUpdated: action.received_at,
                error: { ok: true }
            });
        case _captcha.FAILURE_CAPTCHA:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

exports.default = captchaReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/captcha.js
// module id = 891
// module chunks = 0